/* eslint-disable guard-for-in, no-restricted-syntax */
import clonedeep from 'ramda.clone';
import isEqual from 'lodash.isequal';

import requestReducerFactory from './request-reducer';

const reducersFactory = (actionTypes) =>
    Object.keys(actionTypes).reduce(
        (prev, actionType) => ({
            ...prev,
            [actionType]: requestReducerFactory(actionTypes[actionType]),
        }),
        {},
    );

const createReducers = (actionTypes) => {
    const reducers = reducersFactory(actionTypes);

    const reduce = (stateValue, action) => {
        const mutatableCopy = clonedeep(stateValue);
        for (const currentReducerKey in reducers) {
            // eslint-disable-next-line no-param-reassign
            mutatableCopy[currentReducerKey] = reducers[currentReducerKey](mutatableCopy[currentReducerKey], action);
        }
        return isEqual(stateValue, mutatableCopy) ? stateValue : mutatableCopy;
    };
    return (state = {}, action) => reduce(state, action);
};

export default createReducers;
